// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const kvk: CountryValidator<"NL"> = createValidator(
  "nl.kvk",
  135,
);

export default kvk;
export const compact = kvk.compact;
export const format = kvk.format;
export const validate = kvk.validate;
export const generate = (): string =>
  kvk.generate?.() ??
  (() => {
    throw new Error(
      "Validator nl.kvk cannot generate values",
    );
  })();
